import { SVGProps } from 'react';

export const Project = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3201 21.815H4.32007C3.22007 21.815 2.32007 20.915 2.32007 19.815V3.815C2.32007 2.715 3.22007 1.815 4.32007 1.815H12.3201L18.3201 7.815V13.815H16.3201V8.815H11.3201V3.815H4.32007V19.815H13.3201V21.815ZM17.3201 21.475V19.235L20.2701 22.185L21.6801 20.775L18.7301 17.815H20.9701V15.815H15.3201V21.475H17.3201Z"
      fill="currentColor"
    />
  </svg>
);
